import { useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Layout, Footer, FadeInAnimation, MetaData } from '../components/shared';
import { cmsService } from '../services/homii-services';

const TermsAndConditions = (props) => {    
    const { baseUrlApp, data } = props;
    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const body = _.get(data, 'acf.page_content');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout>
            <MetaData
                title={seoTitle}
                desc={seoMetaDesc}
                canonical={`${baseUrlApp}/notice-per-popia`}
            />
            <div className='container-root container-root-maxWidthLg'>
                <FadeInAnimation wrapDisabled>
                    <div id="terms_privacy_container" dangerouslySetInnerHTML={{ __html: body }} />
                </FadeInAnimation>
            </div>
            <Footer />
        </Layout>
    );
};

export const getServerSideProps = async ({ }) => {
    const resp = await cmsService.RetrieveWordPressPage('notice-per-popia');    
    return {
        props: {
            data: resp
        }
    };
};

export default TermsAndConditions;

TermsAndConditions.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
};
